// extracted by mini-css-extract-plugin
export default {"ticketCount":"TeamMemberAssignedTotal_ticketCount__Xt7lX"};